module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props) ? _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer__top"
  }, [_c('div', {
    staticClass: "footer__container"
  }, [_c('div', {
    staticClass: "footer__social-media"
  }, _vm._l((_vm.props.acf.footer.social), function(button, i) {
    return _c('a', {
      staticClass: "footer__button",
      attrs: {
        "title": "social media open in new tab",
        "href": button.href
      },
      on: {
        "click": function($event) {
          _vm.callGa(i)
        }
      }
    }, [_c('Icon', {
      staticClass: "footer__icon",
      attrs: {
        "name": button.icon
      }
    })], 1)
  })), _c('a', {
    staticClass: "footer__address",
    attrs: {
      "title": "Address Link",
      "href": "props.acf.footer.address_href"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.footer.address)
    }
  }), _c('div', {
    staticClass: "footer__rectangle"
  })])]), _c('div', {
    staticClass: "footer__bottom"
  }, [_c('a', {
    staticClass: "footer__copyright",
    attrs: {
      "title": "Rooster grin",
      "href": "https://www.roostergrin.com/"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.footer.copyright)
    }
  }), _c('div', {
    staticClass: "footer__container-userway-trigger",
    attrs: {
      "id": "accessibilityWidget",
      "tabindex": "0"
    }
  }, [_vm._v("Click for Accessibility")])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a0dd746","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/footer/footer.pug
// module id = 641
// module chunks = 1